
import React from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto, servicioRestfulMinimo} from "../Configuracion";
import {
    CELLTIPO_CADENA, CELLTIPO_COLOR,
    CELLTIPO_ENTERO, CELLTIPO_FECHA,
    CELLTIPO_FOREIGN, CELLTIPO_ICONOACCION, CELLTIPO_ICONOACCION_DESCARGAR, COLUMNVISIBLE_SIEMPRE,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import FormularioBotonera, {
    BOTONERA_ACCION_NUEVO, BOTONERA_ACCION_REFRESCAR,
    BOTONERA_REFRESCAR
} from "../../framework2/ej2/UI/FormularioBotonera";
import Titulo from "../../framework2/ej2/UI/Titulo";
import PropTypes from "prop-types";
import {
    COMPONENTE_TIPO_DATE, COMPONENTE_TIPO_FOREIGN, COMPONENTE_TIPO_FOREIGN_PANTALLA, COMPONENTE_TIPO_FOREIGN_SERVIDOR,
    COMPONENTE_TIPO_INPUT,
    COMPONENTE_TIPO_SELECT,
    COMPONENTE_TIPO_SELECT_MULTI, loadDatos, loadDatosServicio, renderFormulario, renderGrid, showSelectBusqueda
} from "../utils/FormularioUtils";
import Consentimiento from "./Consentimiento";
import {descargarDocumento} from "../utils/DocumentosUtils";

class Consentimientos extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showGrid: true,
            cargandoDatos: false,
            elementoSeleccionado: null,
            datos: [],
            elementoShow: false,
            marcaTiempo: new Date(),
            nuevoConsentimientoShow: false,
        }

        this.columnas= [
            {campo:"fecha", titulo: "Fecha", tipo: CELLTIPO_FECHA, ancho:100},
            {campo:"consentimientotipoCodigo.nombre", titulo: "Tipo", tipo: CELLTIPO_CADENA, ancho:100,},
            {campo:"descargar", tipo: CELLTIPO_ICONOACCION_DESCARGAR, ancho: 50, onAccion: this.descargarConsentimiento},
        ];

    }

    componentDidMount() {
        this.loadDatos();
    }


    nuevoElemento= () => {
        this.setState({showGrid: false, nuevoConsentimientoShow: true});
    }


    loadDatos= () =>{
        const {paciente} = this.props;

        let parametros= {
            pacienteCodigo: paciente ? paciente.codigo : 0,
            //fechas: filtroFechas,
        }
        loadDatosServicio(this, "Consentimiento", "getLista", parametros);
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onAccion= (accion, elemento) => {
        switch (accion){
            case BOTONERA_ACCION_NUEVO:
                this.nuevoElemento();
                break;

            case BOTONERA_ACCION_REFRESCAR:
                this.loadDatos();
                break;
        }
    }

    onAceptar= () => {
        alert ("Consentimiento creado correctamente");
        this.loadDatos();
        this.setState({showGrid: true});
    }

    onCancelar= () => {
        this.setState({showGrid: false});
    }

    descargarConsentimiento= (consentimiento) => {
        const {paciente, elementoSeleccionado} = this.props;
        let nombreArchivo= "cons_" + consentimiento.codigo +  ".pdf";
        let documento= {nombre: nombreArchivo,};
        descargarDocumento("Paciente", paciente.codigo, documento);
    }

    render() {
        const {showGrid, nuevoConsentimientoShow, datos} = this.state;
        const {paciente} = this.props;

        console.log("CONSENTIMIENTOS RENDER");
        console.log("this.columnas: ", this.columnas);

        return (
            <div style={{margin: 8, padding: 4}}>
                {!paciente && <Titulo titulo="Gestión de Consentimientos" soloTitulo={true}/>}

                {Boolean(showGrid) &&
                    <>
                        {renderGrid(this, "Consentimientos", datos, this.onAccion)}
                    </>
                }
                {/* (!Boolean(showGrid) && !Boolean(nuevoConsentimientoShow)) && renderFormulario(this, <Consentimiento paciente={paciente}/>) */}
                { (!Boolean(showGrid) && Boolean(nuevoConsentimientoShow)) &&
                    <Consentimiento paciente={paciente} onAceptar={this.onAceptar} onCancelar={this.onCancelar}/> }

            </div>
        )
    }

}

Consentimientos.propTypes = {
    paciente: PropTypes.object,
    llamador: PropTypes.object,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        datosmaestros: state.datosmaestros,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(Consentimientos);



